import { useQuery } from "@tanstack/react-query"
import { getSellerLeadById } from "@/lib/api/seller-leads.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetSellerLeadById(id: string | null) {
  const { accessToken } = useAuthStore()

  return useQuery({
    queryKey: ["seller-lead", id],
    queryFn: async () => {
      if (!accessToken || !id) throw new Error("Not authenticated or missing id")
      const response = await getSellerLeadById(id, accessToken)
      return response.data
    },
    enabled: !!accessToken && !!id,
  })
}
